import { Button, Col, Form, Input, Row, Select, Space, Switch } from 'antd'
import React, { useMemo } from 'react'

import S3Upload from '@a4b/ui/src/modules/monetisation/puja/molecules/S3Upload'
import { getCardContentFormFields } from './formConfig'

const { TextArea } = Input

interface CardContentFormProps {
    form: any
    onFinish: (values: any) => void
    onCancel: () => void
    isEditing: boolean
    cdnUrl: string
    preSignUrl: string
    submitting?: boolean
}

const CardContentForm: React.FC<CardContentFormProps> = ({
    form,
    onFinish,
    onCancel,
    isEditing,
    cdnUrl,
    preSignUrl,
    submitting = false,
}) => {
    const formFields = useMemo(
        () => getCardContentFormFields(isEditing),
        [isEditing],
    )

    const renderInput = (field: any) => {
        switch (field.type) {
            case 'select':
                return (
                    <Select
                        options={field.options}
                        disabled={field.disabled}
                        placeholder={field.placeholder}
                    />
                )
            case 'textarea':
                return <TextArea rows={field.rows} />
            case 'switch':
                return <Switch />
            case 'upload':
                return (
                    <S3Upload cdnUrl={cdnUrl} preSignUrl={preSignUrl} min={0} max={1} />
                )
            case 'input':
            default:
                return <Input />
        }
    }

    return (
        <Form form={form} layout='vertical' onFinish={onFinish}>
            {formFields.map((row, rIndex) => (
                <Row gutter={16} key={rIndex}>
                    {row.map((field: any, cIndex) => (
                        <Col span={field.span} key={cIndex}>
                            <Form.Item
                                label={field.label}
                                name={field.name}
                                rules={
                                    field.required
                                        ? [
                                            {
                                                required: true,
                                                message:
                                                    field.message || `Please enter ${field.label}`,
                                            },
                                        ]
                                        : []
                                }
                                valuePropName={field.valuePropName}
                                getValueFromEvent={field.getValueFromEvent}
                            >
                                {renderInput(field)}
                            </Form.Item>
                        </Col>
                    ))}
                </Row>
            ))}

            <Form.Item>
                <Space>
                    <Button
                        type='primary'
                        htmlType='submit'
                        loading={submitting}
                        disabled={submitting}
                    >
                        {isEditing ? 'Update' : 'Create'}
                    </Button>
                    <Button onClick={onCancel} disabled={submitting}>
                        Cancel
                    </Button>
                </Space>
            </Form.Item>
        </Form>
    )
}

export default CardContentForm
